import { render, staticRenderFns } from "./listCustomer.vue?vue&type=template&id=4ff4e1b1&scoped=true"
import script from "./listCustomer.vue?vue&type=script&lang=js"
export * from "./listCustomer.vue?vue&type=script&lang=js"
import style0 from "./listCustomer.vue?vue&type=style&index=0&id=4ff4e1b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4e1b1",
  null
  
)

export default component.exports